module.exports = __webpack_public_path__ + "img/property-safe.d27d5116.svg";